import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { useAppSelector } from 'shared/lib/redux';
import { ALERT_VARIANT } from 'shared/ui/alert';

interface AcceptedInviteAlertState {
  isAcceptedInviteAlertVisible: boolean;
  acceptedInviteMessage: null | string;
  acceptedInviteAlertVariant: ALERT_VARIANT;
}

const initialState: AcceptedInviteAlertState = {
  isAcceptedInviteAlertVisible: false,
  acceptedInviteMessage: null,
  acceptedInviteAlertVariant: ALERT_VARIANT.SUCCESS,
};

export const acceptedInviteAlertSlice = createSlice({
  name: 'acceptedInviteAlert',
  initialState,
  reducers: {
    setIsAcceptedInviteAlertVisible: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.isAcceptedInviteAlertVisible = action.payload;
    },
    setAcceptedInviteMessage: (state, action: PayloadAction<string>) => {
      state.acceptedInviteMessage = action.payload;
    },
    setAcceptedInviteAlertVariant: (
      state,
      action: PayloadAction<ALERT_VARIANT>,
    ) => {
      state.acceptedInviteAlertVariant = action.payload;
    },
  },
});

export const {
  setIsAcceptedInviteAlertVisible,
  setAcceptedInviteMessage,
  setAcceptedInviteAlertVariant,
} = acceptedInviteAlertSlice.actions;

export const acceptedInviteAlertReducer = acceptedInviteAlertSlice.reducer;

export const useIsAcceptedInviteAlertVisibleSelector = () =>
  useAppSelector(
    (state) => state.acceptedInviteAlert.isAcceptedInviteAlertVisible,
  );

export const useAcceptedInviteMessageSelector = () =>
  useAppSelector((state) => state.acceptedInviteAlert.acceptedInviteMessage);

export const useAcceptedInviteAlertVariantSelector = () =>
  useAppSelector(
    (state) => state.acceptedInviteAlert.acceptedInviteAlertVariant,
  );
